import styled from 'styled-components';

import { gridStyle, textStyle } from '@themes/mixins';
import DatePicker from '@components/DatePicker';

export const Root = styled.div`
  width: 100%;
  padding: 8px 0;
  margin: 0 auto;
`;
export const Title = styled.div`
  ${textStyle({
    color: 'textPrimary',
    lineHeight: 1,
    size: '16px',
    textAlign: 'left',
    weight: 500,
  })};
  margin-bottom: 16px;
`;
export const StyledDatepicker = styled(DatePicker)`
  margin-bottom: 16px;
`;
export const FormControlWrapper = styled.div``;
export const MemoGroup = styled.div`
  padding: 0 8px 4px 16px;
`;
export const GridWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const ContentColumns = styled.div`
  ${gridStyle({ columnGap: 8, columns: 2, rows: 3 })};
  border-left: 1px solid ${({ theme }) => theme.colors.divider};
`;
